export enum SignoutReason {
  GlobalTimeout = "timed-out",
  DuplicateSession = "bumped-out",
  TimedOutMaxDuration = "timed-out-max-duration",
  UnAuthorized = "unauthorized",
  CompanyOnHold = "CompanyOnHold",
}
